(function($) {

    $('.cb-slider-container').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround:true,
      autoPlay: 1500,
      prevNextButtons: false,
      pageDots: false
    });

    $('.sample-switcher input').on('click', function() {
     const parentContainer = $(this).parents('.switcher-container');
     if ($(this).is(':checked')) {
  
       parentContainer.addClass('active');
       $('[data-selling-plan-group-id] label.sls-selling-plan-group-name').click();
     } else {
       parentContainer.removeClass('active');
       $('.sls-option-container label.sls-selling-plan-group-name:first').click();
     }
   });


  if (window.matchMedia("(max-width: 767px)").matches) {
      $('.cb_product_subscribe').appendTo($('.product__main__content .product__inner')) 
  } 
  
  setTimeout(function () {
    $('#free-sample').removeAttr('disabled');
  }, 2000);

  $('input[name="shot-size"]').change(function (e) {
    let newQty = e.currentTarget.dataset.cbQty;

    if (newQty !== undefined && newQty !== null && newQty !== false) {
      document.querySelector('[name="quantity"]').value = parseInt(newQty);
      document.querySelector('[name="quantity"]').dispatchEvent(new Event('change'));
    }
  });

  $('[data-add-to-cart]').on('click', function(){

    
    // $('[data-drawer-toggle=drawer-cart]')[0].click();

      document.addEventListener('theme:cart:change', function(event) {
        var cart = event.detail.cart;
        if (cart) { 
            console.log(cart)
           $('[data-drawer-toggle=drawer-cart]')[0].click();
        }
      });
    
  })

  // setTimeout(function(){ 

  //     document.addEventListener('theme:cart:change', function(event) {
  //       var cart = event.detail.cart;
  //          $('[data-drawer-toggle=drawer-cart]')[0].click();
  //       if (cart) { 
  //           console.log('11Cart CHANGED')
  //       }
  //     });
    
  // }, 2000)

  // Dynamic change price in button
  let targetPriceEl = document.querySelector('.product__form__inner button [data-button-price]');
  let targetSinglePriceEl = document.querySelector('.product__block__price .product__price [data-product-price]');

  if (targetPriceEl !== null) {
    
    let observer = new MutationObserver(function(mutations) {
      let currQty = parseInt(document.querySelector('[name="quantity"]').value);
      let currPrice = parseFloat(targetPriceEl.innerText.replace('$', ''));
      let currSinglePrice = 0;

      if (currQty === 4) {
        currPrice = currPrice * 0.8;
        currSinglePrice = currPrice / 4;
      } else if (currQty === 3) {
        currPrice = currPrice * 0.85;
        currSinglePrice = currPrice / 3;
      } else if (currQty === 2) {
        currPrice = currPrice * 0.9;
        currSinglePrice = currPrice / 2;
      } else {
        currPrice = 0;
      }
  
      if (currPrice !== 0) {
        targetPriceEl.classList.add('cb-crossed-text');
        document.querySelector('[data-cb-button-disc-price]').innerHTML = '$' + currPrice.toFixed(2);
        targetSinglePriceEl.classList.add('cb-crossed-text');
        document.querySelector('.product__block__price .product__price [data-cb-disc-price]').innerHTML = '$' + currSinglePrice.toFixed(2);
      } else {
        targetPriceEl.classList.remove('cb-crossed-text');
        document.querySelector('[data-cb-button-disc-price]').innerHTML = '';
        targetSinglePriceEl.classList.remove('cb-crossed-text');
        document.querySelector('.product__block__price .product__price [data-cb-disc-price]').innerHTML = '';
      }
    });
  
    observer.observe(targetPriceEl, {
        childList:     true,
        characterData: true
    });
  }

  

  
})(jQuery);



document.addEventListener('sealsubs:price_update', function(e) {
  window.cbSealSRefreshEvent = e;
});




/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {


  
  
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   console.log(cart)
  //   if (cart) { 

  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
